import React, { Fragment, useEffect } from 'react';
import { Spinner } from 'reactstrap';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { compactNumber } from '../../common/numberFormat';
import useUser from '../../hooks/useUser';

/**
 * Builde Token Balance Component
 * 
 * Shows current user Builde token balance in NavBar
 */
function BuildeTokenBalance({ showCurrency }) {
    const useUserTokenBalance = useUser();
    const isAuthenticated = useIsAuthenticated();
    const { inProgress, accounts } = useMsal();

    showCurrency = showCurrency !== undefined ? showCurrency : true;

    useEffect(() => {
		if (inProgress === InteractionStatus.None) {
			if (isAuthenticated && accounts?.length > 0) {
				useUserTokenBalance.getBuildeTokens();
            }
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, inProgress]);

    const Currency = () => {
        return (
            <Fragment>
                <span>&nbsp;</span>
                <span className='builde-token-balance-currency'>BLDE</span>
            </Fragment>
        )
    }

    const TokenBalance = () => {
        return (
            <Fragment>
                <span className={ useUserTokenBalance.buildeTokenBalance !== null
                        && useUserTokenBalance.buildeTokenBalance >= 0
                            ? 'text-white' : 'text-warning' }>
                    <span className='builde-token-balance-amount'>{ compactNumber(useUserTokenBalance.buildeTokenBalance, 2) }</span>
                    {
                        showCurrency &&
                        <Currency />
                    }
                </span>
            </Fragment>
        )
    }

    const NoBalance = () => {
        return (
            <Fragment>
                <span className='secondary'>
                    <span>-</span>
                </span>
            </Fragment>
        )
    }

    const Loading = () => {
        return (
            <Spinner color="secondary" size="sm">
                Loading...
            </Spinner>
        )
    }

    return (
        useUserTokenBalance.loading ? 
            <Loading />
        :
        useUserTokenBalance.buildeTokenBalance !== null && useUserTokenBalance.buildeTokenBalance >= 0 ? (
            <TokenBalance />
        ) :
        useUserTokenBalance.error && (
            <NoBalance />
        )
    );
}

export default BuildeTokenBalance;
